__turbopack_context__.v({
  "captionDarkMode": "styles-module-scss-module__UvH2Ca__captionDarkMode",
  "captionText": "styles-module-scss-module__UvH2Ca__captionText",
  "gameDialogCaption": "styles-module-scss-module__UvH2Ca__gameDialogCaption",
  "gameDialogDescription": "styles-module-scss-module__UvH2Ca__gameDialogDescription",
  "gameLandingCaption": "styles-module-scss-module__UvH2Ca__gameLandingCaption",
  "gameLandingDescription": "styles-module-scss-module__UvH2Ca__gameLandingDescription",
});
